import { useEffect, useState } from 'react';
import { JsonData, JsonDataItem } from 'types';
import Big from 'big.js';

export const useAppointmentDuration = (
  job: JsonDataItem | null,
  productList: JsonData | null,
  productSelection: JsonDataItem | null,
) => {
  const [appointmentDuration, setAppointmentDuration] = useState<number>(0);

  useEffect(() => {
    if (job) {
      // reschedule
      const duration = job.products.reduce((acc: Big, jobProduct: JsonDataItem) => {
        const productDuration = new Big(jobProduct.product.duration || 0);
        const quantity = new Big(jobProduct.product.quantity || 1);
        return acc.plus(productDuration.times(quantity));
      }, new Big(0));
      setAppointmentDuration(duration.toNumber());
    } else if (productSelection && productList) {
      // new booking
      const duration = productSelection.products.reduce((acc: Big, selectedProduct: JsonDataItem) => {
        const product = productList.find((p) => p.ID.toString() === selectedProduct.id);
        if (product) {
          const productDuration = new Big(product.duration || 0);
          const quantity = new Big(selectedProduct.qty || 1);
          return acc.plus(productDuration.times(quantity));
        }
        return acc;
      }, new Big(0));
      setAppointmentDuration(duration.toNumber());
    }
  }, [productSelection, productList, job]);

  return appointmentDuration;
};
